
// client/src/utils/filterItems.js
const FILTER_ITEMS = [
  { url: 'all', value: null, name: 'Todos', displayName: 'Todos' },
  { url: 'actives', value: false, name: 'Activos', displayName: 'Activos' },
  { url: 'inactives', value: true, name: 'Inactivos', displayName: 'Inactivos' },
];

export default FILTER_ITEMS;

  